import {SET_PRESTASHOP_PRODUCTS} from "../actions/constants";
import {createReducer} from "../../../_common/common.ts";

export const prestashopProducts = createReducer(null, {
    [SET_PRESTASHOP_PRODUCTS]: (state, payload)=> payload
});
